const CONFIG = {
  "metadata": {
    "version": "2026.06.16",
    "name": "Women's Health Survey",
    "description": "Women's health module for the perceptual survey. First-pass intake from the May 2026 questionnaire; conditional logic is handled in app code."
  },
  "structure": [
    {
      "id": "reproductive_stage",
      "type": "multiple_choice",
      "title": "Stage",
      "answer_type": "string",
      "infoText": "Which of the following is currently true?",
      "include_na": false,
      "options": [
        "Pregnant",
        "Lactating/Breastfeeding",
        "Currently have a cycle/menstruating",
        "No longer have a cycle/menstruating for a year or more"
      ],
      "translation": {
        "gu": {
          "title": "તબક્કો",
          "infoText": "નીચેનામાંથી કયું હાલમાં સાચું છે?",
          "options": [
            "સગર્ભા",
            "સ્તનપાન કરાવતી",
            "હાલમાં ચક્ર/માસિક સ્રાવ છે",
            "એક વર્ષ કે તેથી વધુ સમયથી માસિક આવતું નથી "
          ]
        },
        "hi": {
          "title": "अवस्था",
          "infoText": "वर्तमान में निम्नलिखित में से कौन सा सत्य है?",
          "options": [
            "गर्भवती",
            "स्तनपान कराने वाली",
            "वर्तमान में मासिक चक्र / माहवारी आती है",
            "एक वर्ष या उससे अधिक समय से मासिक चक्र / माहवारी नहीं आती"
          ]
        },
        "es": {
          "title": "Etapa",
          "infoText": "¿Cuál de las siguientes opciones es cierta actualmente?",
          "options": [
            "Embarazada",
            "Lactando/Amamantando",
            "Actualmente tengo ciclo/menstruando",
            "Ya no tengo ciclo/menstruación desde hace un año o más"
          ]
        }
      }
    },
    {
      "id": "pregnancy_due_date",
      "type": "date",
      "title": "Due Date",
      "infoText": "When is your due date?",
      "include_na": true,
      "translation": {
        "gu": {
          "title": "નિયત તારીખ",
          "infoText": "ડિલિવરી લગભગ ક્યારે છે?"
        },
        "hi": {
          "title": "प्रसव की तारीख",
          "infoText": "आपकी प्रसव की तारीख कब है?"
        },
        "es": {
          "title": "Fecha de Parto",
          "infoText": "¿Cuándo es su fecha de parto?"
        }
      }
    },
    {
      "id": "pregnancy_end_date",
      "type": "date",
      "title": "End Date",
      "infoText": "When did your pregnancy end?",
      "include_na": true,
      "translation": {
        "gu": {
          "title": "સમાપ્તિ તારીખ",
          "infoText": "તમારી ગર્ભાવસ્થા ક્યારે સમાપ્ત થઈ?"
        },
        "hi": {
          "title": "समाप्ति तिथि",
          "infoText": "आपकी गर्भावस्था कब समाप्त हुई?"
        },
        "es": {
          "title": "Fecha de Finalización",
          "infoText": "¿Cuándo terminó su embarazo?"
        }
      }
    },
    {
      "id": "last_cycle_timing",
      "type": "multiple_choice",
      "answer_type": "string",
      "title": "Last Cycle",
      "infoText": "If no longer menstruating: when was your last cycle?",
      "options": [
        "Less than 1 year ago",
        "About 1 year ago",
        "Between 1 and 5 years ago",
        "Over 5 years ago"
      ],
      "include_other": true,
      "include_na": true,
      "translation": {
        "gu": {
          "title": "છેલ્લા માસિક ની તારીખ ",
          "infoText": "જો માસિક ન આવે તો: તમારું છેલ્લું માસિક ક્યારે હતું?",
          "options": [
            "૧ વર્ષથી ઓછા સમય પહેલાં",
            "લગભગ ૧ વર્ષ પહેલાં",
            "૧ થી ૫ વર્ષ પહેલાં",
            "૫ વર્ષથી વધુ સમય પહેલાં"
          ]
        },
        "hi": {
          "title": "पिछली माहवारी",
          "infoText": "यदि अब माहवारी नहीं आती: आपकी पिछली माहवारी कब थी?",
          "options": [
            "1 वर्ष से कम समय पहले",
            "लगभग 1 वर्ष पहले",
            "1 से 5 वर्ष पहले",
            "5 वर्ष से अधिक पहले"
          ]
        },
        "es": {
          "title": "Último Ciclo",
          "infoText": "Si ya no menstrúa: ¿cuándo fue su último ciclo?",
          "options": [
            "Hace menos de 1 año",
            "Hace aproximadamente 1 año",
            "Entre 1 y 5 años atrás",
            "Hace más de 5 años"
          ]
        }
      }
    },
    {
      "id": "hf_ns_present",
      "type": "binary",
      "title": "Hot Flushes / Night Sweats",
      "infoText": "Do you have any hot flushes or night sweats?",
      "yes": "Yes",
      "no": "No",
      "include_na": false,
      "translation": {
        "gu": {
          "title": "અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો",
          "infoText": "શું તમને કોઈ અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો થાય છે?",
          "yes": "હા",
          "no": "ના"
        },
        "hi": {
          "title": "गर्म झलक / रात को पसीना",
          "infoText": "क्या आपको गर्म झलक या रात को पसीना आता है?",
          "yes": "हाँ",
          "no": "नहीं"
        },
        "es": {
          "title": "Sofocos / Sudores Nocturnos",
          "infoText": "¿Tiene sofocos o sudores nocturnos?",
          "yes": "Sí",
          "no": "No"
        }
      }
    },
    {
      "id": "hf_ns_frequency_last_week",
      "type": "numeric",
      "title": "HF/NS Frequency (Last Week)",
      "infoText": "How often have you had hot flushes or night sweats in the last week? (number of episodes)",
      "min_value": 0,
      "max_value": 200,
      "precision": 0,
      "include_na": true,
      "translation": {
        "gu": {
          "title": "અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો કેટલા અંતરે થયું (ગયા અઠવાડિયે)",
          "infoText": "છેલ્લા અઠવાડિયામાં તમને કેટલી વારઅતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો થયો છે? (એપિસોડની સંખ્યા)"
        },
        "hi": {
          "title": "गर्म झलक / रात को पसीना की आवृत्ति (पिछले सप्ताह)",
          "infoText": "पिछले सप्ताह में आपको कितनी बार गर्म झलक या रात को पसीना आया? (एपिसोड की संख्या)"
        },
        "es": {
          "title": "Frecuencia de Sofocos/Sudores (Última Semana)",
          "infoText": "¿Con qué frecuencia ha tenido sofocos o sudores nocturnos en la última semana? (número de episodios)"
        }
      }
    },
    {
      "id": "hf_ns_problem_rating",
      "type": "numeric_scale",
      "title": "Problem Rating",
      "infoText": "To what extent do you regard your HF/NS as a problem?",
      "min_value": 0,
      "max_value": 10,
      "min_text": "Not a Problem at All",
      "max_text": "Very Much a Problem",
      "include_na": true,
      "translation": {
        "gu": {
          "title": "સમસ્યા રેટિંગ",
          "infoText": "તમે તમારા અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો ને કેટલી હદ સુધી સમસ્યા માનો છો?",
          "min_text": "બિલકુલ સમસ્યા નથી",
          "max_text": "ખૂબ જ સમસ્યા"
        },
        "hi": {
          "title": "समस्या की रेटिंग",
          "infoText": "आप अपनी गर्म झलक / रात को पसीना को किस हद तक समस्या मानती हैं?",
          "min_text": "बिल्कुल समस्या नहीं",
          "max_text": "बहुत बड़ी समस्या"
        },
        "es": {
          "title": "Calificación del Problema",
          "infoText": "¿En qué medida considera sus sofocos/sudores nocturnos como un problema?",
          "min_text": "No es un problema en absoluto",
          "max_text": "Es un problema muy grande"
        }
      }
    },
    {
      "id": "hf_ns_distress_rating",
      "type": "numeric_scale",
      "title": "Distress Rating",
      "infoText": "How distressed do you feel about your HF/NS?",
      "min_value": 0,
      "max_value": 10,
      "min_text": "Not Distressed at All",
      "max_text": "Very Much Distressed",
      "include_na": true,
      "translation": {
        "gu": {
          "title": "તકલીફ રેટિંગ",
          "infoText": "તમે તમારા અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો વિશે કેટલી તાણ અનુભવો છો?",
          "min_text": "બિલકુલ તણાવ નથી",
          "max_text": "ખૂબ જ તાણ થાય છે "
        },
        "hi": {
          "title": "परेशानी की रेटिंग",
          "infoText": "आप अपनी गर्म झलक / रात को पसीना के बारे में कितनी परेशान महसूस करती हैं?",
          "min_text": "बिल्कुल परेशान नहीं",
          "max_text": "बहुत परेशान"
        },
        "es": {
          "title": "Calificación de Angustia",
          "infoText": "¿Qué tan angustiada se siente por sus sofocos/sudores nocturnos?",
          "min_text": "Nada angustiada",
          "max_text": "Muy angustiada"
        }
      }
    },
    {
      "id": "hf_ns_interference_rating",
      "type": "numeric_scale",
      "title": "Daily-Routine Interference",
      "infoText": "How much do your HF/NS interfere with your daily routine?",
      "min_value": 0,
      "max_value": 10,
      "min_text": "Not at All",
      "max_text": "Very Much",
      "precision": 0,
      "include_na": true,
      "translation": {
        "gu": {
          "title": "દૈનિક-નિયમિત તાણ થાય છે ",
          "infoText": "તમારા અતિશય ગરમી અને ગભરામણ / રાત્રે પરસેવો તમારા દિનચર્યામાં તમને કેટલું હેરાન કરે છે ? ",
          "min_text": "બિલકુલ નહીં",
          "max_text": "ખૂબ વધારે"
        },
        "hi": {
          "title": "दैनिक दिनचर्या में बाधा",
          "infoText": "आपकी गर्म झलक / रात को पसीना आपकी दैनिक दिनचर्या में कितनी बाधा डालती हैं?",
          "min_text": "बिल्कुल नहीं",
          "max_text": "बहुत अधिक"
        },
        "es": {
          "title": "Interferencia en la Rutina Diaria",
          "infoText": "¿Cuánto interfieren sus sofocos/sudores nocturnos con su rutina diaria?",
          "min_text": "Nada",
          "max_text": "Mucho"
        }
      }
    },
    {
      "id": "cycle_regular",
      "type": "multiple_followup",
      "followup_type": "numeric",
      "title": "Cycle Regularity",
      "infoText": "Have your cycles been regular (at about the same time every month) in the last 3 months?",
      "followup_infoText": "About how many cycles have you had in the last 12 months?",
      "min_value": 0,
      "max_value": 20,
      "options": [
        "Yes",
        "No",
        "Don’t know"
      ],
      "show_followup_on_answer": [
        "No",
        "Don’t know"
      ],
      "translation": {
        "gu": {
          "title": "માસિક ની નિયમિતતા",
          "followup_infoText": "છેલ્લા ૧૨ મહિનામાં તમને કેટલી વાર માસિક આવ્યા ? ",
          "options": [
            "હા",
            "ના",
            "ખબર નહીં "
          ]
        },
        "hi": {
          "title": "मासिक चक्र की नियमितता",
          "infoText": "क्या पिछले 3 महीनों में आपके मासिक चक्र नियमित रहे हैं (लगभग हर महीने एक ही समय पर)?",
          "followup_infoText": "पिछले 12 महीनों में आपको लगभग कितनी बार माहवारी आई है?",
          "options": [
            "हाँ",
            "नहीं",
            "पता नहीं"
          ]
        },
        "es": {
          "title": "Regularidad del Ciclo",
          "infoText": "¿Han sido regulares sus ciclos (aproximadamente a la misma hora cada mes) en los últimos 3 meses?",
          "followup_infoText": "¿Aproximadamente cuántos ciclos ha tenido en los últimos 12 meses?",
          "options": [
            "Sí",
            "No",
            "No sé"
          ]
        }
      }
    },
    {
      "id": "cycle_change",
      "type": "multiple_followup",
      "followup_type": "multiple_choice_answer",
      "title": "Cycle Change",
      "infoText": "My cycles change when it gets hot.",
      "followup_infoText": "How do they change (select all that apply)?",
      "options": [
        "Yes",
        "No",
        "Don’t know"
      ],
      "followup_options": [
        "More frequent",
        "Less frequent",
        "Shorter",
        "Longer"
      ],
      "followup_include_na": false,
      "followup_include_other": false,
      "show_followup_on_answer": [
        "Yes"
      ],
      "translation": {
        "gu": {
          "title": "માસિકમાં બદલાવ  ",
          "infoText": "ગરમી થાય ત્યારે મારા માસિકમાં બદલાવ આવે છે  ",
          "followup_infoText": "માસિક કેવી રીતે બદલાય છે (લાગુ પડતા બધા પસંદ કરો)?",
          "options": [
            "હા",
            "ના",
            "ખબર નહીં "
          ],
          "followup_options": [
            "વધુ વારંવાર આવે છે ",
            "ઓછા થઇ જાય છે ",
            "ટૂંકા",
            "લાંબા"
          ]
        },
        "hi": {
          "title": "मासिक चक्र में बदलाव",
          "infoText": "गर्मी होने पर मेरे मासिक चक्र में बदलाव आता है।",
          "followup_infoText": "वे कैसे बदलते हैं (लागू सभी विकल्प चुनें)?",
          "options": [
            "हाँ",
            "नहीं",
            "पता नहीं"
          ],
          "followup_options": [
            "अधिक बार",
            "कम बार",
            "छोटे",
            "लंबे"
          ]
        },
        "es": {
          "title": "Cambio del Ciclo",
          "infoText": "Mis ciclos cambian cuando hace calor.",
          "followup_infoText": "¿Cómo cambian (seleccione todas las que correspondan)?",
          "options": [
            "Sí",
            "No",
            "No sé"
          ],
          "followup_options": [
            "Más frecuentes",
            "Menos frecuentes",
            "Más cortos",
            "Más largos"
          ]
        }
      }
    },
    {
      "id": "work_through_cycle",
      "type": "binary_followup",
      "followup_type": "multiple_choice_answer",
      "title": "Cycle Work",
      "infoText": "Can you work during your menstrual cycle?",
      "yes": "Yes",
      "no": "No",
      "followup_infoText": "Why?",
      "options": [
        "Yes",
        "No",
        "Don’t know"
      ],
      "followup_options": [
        "Lack of toilets",
        "No place to dispose of sanitary pads",
        "discomfort"
      ],
      "followup_include_na": false,
      "followup_include_other": true,
      "show_followup_on_answer": "no",
      "translation": {
        "gu": {
          "title": "માસિક દરમિયાન કામ ",
          "infoText": "શું તમે તમારા માસિક ચક્ર દરમિયાન કામ કરી શકો છો?",
          "yes": "હા",
          "no": "ના",
          "followup_infoText": "શા માટે?",
          "followup_options": [
            "શૌચાલયનો અભાવ",
            "સેનિટરી પેડ્સનો નિકાલ કરવાની જગ્યા નથી",
            "અગવડતા"
          ]
        },
        "hi": {
          "title": "माहवारी के दौरान काम",
          "infoText": "क्या आप अपनी माहवारी के दौरान काम कर सकती हैं?",
          "yes": "हाँ",
          "no": "नहीं",
          "followup_infoText": "क्यों?",
          "followup_options": [
            "शौचालय का अभाव",
            "सेनिटरी पैड्स को फेंकने के लिए कोई जगह नहीं",
            "असुविधा"
          ]
        },
        "es": {
          "title": "Trabajo durante el Ciclo",
          "infoText": "¿Puede trabajar durante su ciclo menstrual?",
          "yes": "Sí",
          "no": "No",
          "followup_infoText": "¿Por qué?",
          "followup_options": [
            "Falta de baños",
            "No hay lugar para desechar las toallas sanitarias",
            "Malestar"
          ]
        }
      }
    }
  ]
} 
export default CONFIG